import React, { useCallback } from 'react'
import { useParams } from 'react-router'
import { useAppDispatch } from '../../../hooks/redux'
import { fillValuesForRelist } from '../../../store/actionsCreators/setUnitActions'
import SetUnitModal, { type UnitCreationPresentation } from './SetUnitModal'

const presentation: UnitCreationPresentation = {
    header: 'Relist Unit',
    submitLabel: 'Continue to marketing',
    notice: 'A new unit listing will be created. Previous advertisements, viewings, offers and statistics will remain attached to the old unit.'
}

const RelistUnitModal = (): JSX.Element => {
    const { unitID } = useParams()
    const dispatch = useAppDispatch()
    const sourceUnitId = Number(unitID)
    const initializeSource = useCallback((id: number) => fillValuesForRelist(id), [])
    const afterCreate = useCallback(async (newUnitId: number): Promise<{ isSuccessful: boolean }> => {
        if (!Number.isFinite(sourceUnitId)) return { isSuccessful: false }
        window.sessionStorage.setItem(`relist-marketing-${String(newUnitId)}`, JSON.stringify({ sourceUnitId, targetUnitId: newUnitId }))
        return { isSuccessful: true }
    }, [sourceUnitId])

    return <SetUnitModal sourceUnitId={sourceUnitId} presentation={presentation} initializeSource={initializeSource} afterCreate={afterCreate} />
}

export default RelistUnitModal
